// Orchestrator lives in `owa-mail-popout-reading-pane` so it can call
// `lazyReplyToMessage` without `owa-personal-os-option` depending on
// the mail compose stack — that direct dep would close a project-ref
// cycle through Copilot Settings.

import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type { MyOutlookProactiveDraftInfo } from 'owa-personal-os-types';

export interface OpenDraftReplyFromBriefingActionMessage {
    messageId: string;
    body: string;
    mailboxInfo: MailboxInfo;
    conversationId?: string;
    // Briefing-projection id used to mark the item done on send; absent for
    // fallback-keyed items that have no server id.
    itemId?: string;
    draftInfo?: MyOutlookProactiveDraftInfo;
}

export const openDraftReplyFromBriefing: (
    messageId: string,
    body: string,
    mailboxInfo: MailboxInfo,
    conversationId?: string,
    itemId?: string,
    draftInfo?: MyOutlookProactiveDraftInfo
) => OpenDraftReplyFromBriefingActionMessage = action(
    'OPEN_DRAFT_REPLY_FROM_BRIEFING',
    (
        messageId: string,
        body: string,
        mailboxInfo: MailboxInfo,
        conversationId?: string,
        itemId?: string,
        draftInfo?: MyOutlookProactiveDraftInfo
    ) => ({
        messageId,
        body,
        mailboxInfo,
        conversationId,
        itemId,
        draftInfo,
    })
);
